var ZebraPrinting = (function (backOffice, $) {
    backOffice.ZebraPrinting = (function () {
        var aPrintValues = new Array();
        var aPrintQty = new Array();
        var aPrintWH = new Array();
        var sPrintName = "Rex_LabelPrintName";
        var sErrorInstallJsPrint ='<p class="text-alert"><strong>Note:</strong> JS Print Manager is not running on this computer and is required for Zebra Label printing.'
            +' Click <strong><a href="https://galaxy.maropost.com/s/article/Zebra-Label-Printer-Installation" class="text-alert" target="_blank">HERE</a></strong> for details.</p>';
        //Check JSPM WebSocket status 
        function jspmWSStatus() {
            if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open)
                return true;
            else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Closed) {
                document.getElementById('JSPrintManagerId').style.display = "none";
                //alert('JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm');
                return false;
            }
            else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Blocked) {
                alert('JSPM has blocked this website!');
                return false;
            }
        }

        // Send Job to Printer        
        function sendJobToPrinter(data) {
            if (jspmWSStatus()) {
                //Create a ClientPrintJob
                var cpj = new JSPM.ClientPrintJob();
                cpj.clientPrinter = new JSPM.InstalledPrinter($('#installedPrinterName').val());
                //Set content to print...
                //Create Zebra EPL commands for data label                  
                cpj.printerCommands = data;
                //Send print job to printer!
                cpj.sendToClient();
            }
        }
        // Download file EPL/ZPL
        function downloadPrintCode(data, fileName) {
            const blob = new Blob([data], { type: 'code/text' });
            const downloadUrl = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = downloadUrl;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
        }

        function setSelectedPrint(cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = sPrintName + "=" + cvalue + ";" + expires + ";path=/";
        }
        function getSelectedPrint() {
            var name = sPrintName + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }
        function initJsPrintManager(customErrorMessage = null) {
            //WebSocket settings     
            JSPM.JSPrintManager.license_url = window.location.origin + "/dotnet/admin/api/jspm/license";
            JSPM.JSPrintManager.auto_reconnect = true;
            JSPM.JSPrintManager.start();
            JSPM.JSPrintManager.WS.onStatusChanged = function () {
                if (jspmWSStatus()) {
                    //get client installed printers          
                    JSPM.JSPrintManager.getPrinters().then(function (myPrinters) {
                        var sValue = "The Operating System's available printers";
                        var options = '<option value="' + sValue + '">Select from Available Printers</option>';
                        for (var i = 0; i < myPrinters.length; i++) {

                            if (myPrinters[i] === getSelectedPrint()) {
                                options += '<option selected>' + myPrinters[i] + '</option>';
                            } else {
                                options += '<option>' + myPrinters[i] + '</option>';
                            }
                        }
                        $('#installedPrinterName').html(options);
                    });

                    $("#JSPrintManagerId").css("display", '');
                    $("#jsPrintMessage").css("display", 'none');
                    $("#jsPrintMessage").html('');
                }
                else {
                    $("#JSPrintManagerId").css("display", 'none');
                    $("#jsPrintMessage").css("display", '');
                    if (customErrorMessage === '' || customErrorMessage == null || customErrorMessage == 'undefined') {
                        $("#jsPrintMessage").html(sErrorInstallJsPrint);
                    } else {
                        $("#jsPrintMessage").html(customErrorMessage);
                    }

                }

            }
        }
        // Zebra JS Print On Receipt page
        function zebraPrintOnReceipt(what, iWarehouseID, btn) {
            //Copy across from respective fields otherwise just leave what's there
            if (what == 'Receiving' || what == 'Received') {
                for (var i in aQtyRcdInputs) {
                    aPrintingInputs[i].value = what == 'Receiving' ? aQtyRcdInputs[i].value : aQtyRcdLables[i].innerHTML;
                }
            }
            if (jspmWSStatus()) {

                showLoading(btn);

                //Create a ClientPrintJob
                var cpj = new JSPM.ClientPrintJob();
                cpj.clientPrinter = new JSPM.InstalledPrinter($('#installedPrinterName').val());
                iLabelwhid = iWarehouseID;

                // Iterate the objects for printing
                var oTable = document.getElementById('results');
                var aInputs = oTable.getElementsByTagName('INPUT');
                //
                // Just do all the request in 1 hit
                var products = new Array();
                var quantities = new Array();
                for (var x = 0; x < aInputs.length; x++) {
                    // Ensure that there is a numeric value > 0
                    if (aInputs[x].getAttribute('name') == 'quantity' && !(aInputs[x].value == '' || isNaN(aInputs[x].value))) {
                        if (aInputs[x].value > 0) {
                            quantities.push(aInputs[x].value);
                            products.push(aInputs[x].getAttribute('productid'));
                        }
                    }
                }                         
                var printData = '';
                while (quantities.length > 0) {
                    var formData = 'productid=' + products[0].toString();
                    formData += '&quantity=' + quantities[0].toString();
                    formData += '&labelwhid=' + iLabelwhid;
                    formData += '&ipresetid=' + $('#templateName').val();                 
                    $.ajax({
                        method: "POST",
                        url: "/Admin/Inventory/StockReceipt/StockReceiptBarcodes/zebraPrint.asp",
                        data: formData,
                        async: false,
                        success: function (data) {
                            printData += data;
                        }
                    });
                    quantities.shift();
                    products.shift();
                }
                if (printData != '') {
                    sendJobToPrinter(printData);
                }
                setTimeout(function () {
                    hideLoading(btn, btn.value);
                }, 300);
            }
        }
        function zebraOnReceiptDownload(type, what, iWarehouseID) {

            if (what == 'Receiving' || what == 'Received') {
                for (var i in aQtyRcdInputs) {
                    aPrintingInputs[i].value = what == 'Receiving' ? aQtyRcdInputs[i].value : aQtyRcdLables[i].innerHTML;
                }
            }

            iLabelwhid = iWarehouseID;
            // Iterate the objects for printing
            var oTable = document.getElementById('results');
            var aInputs = oTable.getElementsByTagName('INPUT');

            // Just do all the request in 1 hit
            var products = new Array();
            var quantities = new Array();
            for (var x = 0; x < aInputs.length; x++) {
                // Ensure that there is a numeric value > 0
                if (aInputs[x].getAttribute('name') == 'quantity' && !(aInputs[x].value == '' || isNaN(aInputs[x].value))) {
                    if (aInputs[x].value > 0) {
                        quantities.push(aInputs[x].value);
                        products.push(aInputs[x].getAttribute('productid'));
                    }
                }
            }
            var templateName = $("#templateName option:selected").text();
            var fileName = "Labels_" + templateName + "_" + what + ".epl";
            var printData = '';
            while (quantities.length > 0) {
             
                var formData = 'productid=' + products[0].toString();
                formData += '&quantity=' + quantities[0].toString();
                formData += '&labelwhid=' + iLabelwhid;
                formData += '&ipresetid=' + $('#templateName').val();
                if (type === 'ZPL') {
                    formData += '&idownloadzpl=true';
                    fileName = "Labels_" + templateName + "_" + what + ".zpl";
                }
                $.ajax({
                    method: "POST",
                    url: "/Admin/Inventory/StockReceipt/StockReceiptBarcodes/zebraPrint.asp",
                    data: formData,
                    async: false,
                    success: function (data) {
                       printData+= data;  
                    }
                });
                quantities.shift();
                products.shift();
            }
            if (printData != '') {
                downloadPrintCode(printData,fileName);
            }
        }
        function setZebraTemplate(key) {
            var sZebraTemplateName;
            var keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
            sZebraTemplateName = keyValue ? keyValue[2] : null;
            $("#templateName > option").each(function () {
                if (this.value == sZebraTemplateName) {
                    var element = document.getElementById("templateName");
                    element.value = sZebraTemplateName;
                }
            });
        }
        function getZebraTemplate(key) {
            var sZebraTemplateName;
            var keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
            sZebraTemplateName = keyValue ? keyValue[2] : '';
            return sZebraTemplateName;           
        }

        function zebraPrintOnITOReport(aQty, aProductIds, aWhidTo, btn) {
            showLoading(btn); 
            aPrintValues.length = 0;
            aPrintQty.length = 0;
            aPrintWH.length = 0;

            for (var i in aWhidTo) {
                if (aPrintWH.filter(function (x) { return x == aWhidTo[i]; }).length == 0)
                    aPrintWH.push(aWhidTo[i]);
            }

            let printValues = new Array();
            let printQty = new Array();
            for (var i in aPrintWH) {
                printValues.length = 0;
                printQty.length = 0;
                for (var j in aWhidTo) {
                    if (aWhidTo[j] == aPrintWH[i]) {
                        let qty = parseInt(aQty[j]);
                        if (qty > 0) {
                            if (printValues.filter(function (x) { return x == aProductIds[0][j]; }).length == 0) {
                                printValues.push(aProductIds[0][j]);
                                printQty.push(qty);
                            }
                            else {
                                let index = printValues.indexOf(aProductIds[0][j]);
                                printQty[index] += parseInt(qty);
                            }
                        }
                    }
                }

                if (printValues.length > 0) {
                    aPrintValues.push(printValues.join());
                    aPrintQty.push(printQty.join());
                }
            }
            var printData = '';           
            while (aPrintValues.length > 0) {
                //	displayMessage("text-alert", "info-sign", "Requesting data for next item in the cue to be printed.");             
                var formData = 'productid=' + aPrintValues[0];
                formData += '&quantity=' + aPrintQty[0];
                formData += '&labelwhid=' + aPrintWH[0];
                formData += '&ipresetid=' + $('#templateName').val();

                $.ajax({
                    type: "POST",
                    url: "/Admin/Inventory/StockReceipt/StockReceiptBarcodes/zebraPrint.asp",
                    data: formData,
                    async: false,                   
                    success: function (data) {
                        printData += data;
                    }
                });

                aPrintValues.shift();
                aPrintQty.shift();
                aPrintWH.shift();
            }
            
            if (printData != '') {
                sendJobToPrinter(printData);
            }
             setTimeout(function() {
              hideLoading(btn, btn.value);         
            }, 300);
           
        }

        // For LabelPrint.asp
        function zebraOnLabelPrintDownload(downloadType) {
            aProducts.length = 0;
            iLabelwhid = document.getElementById('labelwhid').value;
            // displayMessage("text-alert", "info-sign", "Preparing print list.");

            // Iterate the objects for printing       
            var aInputs = $("#results tbody input[name=quantity]");

            var products = new Array();
            var quantities = new Array();

            for (var x = 0; x < aInputs.length; x++) {
                // Ensure that there is a numeric value > 0
                if (aInputs[x].getAttribute('name') == 'quantity' && !(aInputs[x].value == '' || isNaN(aInputs[x].value))) {
                    if (aInputs[x].value > 0) {
                        quantities.push(aInputs[x].value);
                        products.push(aInputs[x].getAttribute('productid'));
                    }
                }
            }

            var formData = 'productid=' + products.toString();
            formData += '&quantity=' + quantities.toString();
            formData += '&labelwhid=' + iLabelwhid;
            formData += '&ipresetid=' + $('#templateName').val();
            
            var templateName = $("#templateName option:selected").text();
            var fileName = "Labels_" + templateName + ".epl";

            if (downloadType === 'ZPL') {
                formData += '&idownloadzpl=true';
                fileName = "Labels_" + templateName + ".zpl";
            }

            $.ajax({
                method: "POST",
                url: "/Admin/Inventory/StockReceipt/StockReceiptBarcodes/zebraPrint.asp",
                data: formData,
                success: function (data) {
                    downloadPrintCode(data, fileName);
                }
            });
        }
        function zebraPrintOnLabelPrint(btn) {
            if (jspmWSStatus()) {

                showLoading(btn);

                //Create a ClientPrintJob
                var cpj = new JSPM.ClientPrintJob();
                cpj.clientPrinter = new JSPM.InstalledPrinter($('#installedPrinterName').val());

                aProducts.length = 0;
                iLabelwhid = document.getElementById('labelwhid').value;
                // displayMessage("text-alert", "info-sign", "Preparing print list.");

                // Iterate the objects for printing
                var aInputs = $("#results tbody input[name=quantity]");

                var products = new Array();
                var quantities = new Array();

                for (var x = 0; x < aInputs.length; x++) {
                    // Ensure that there is a numeric value > 0
                    if (aInputs[x].getAttribute('name') == 'quantity' && !(aInputs[x].value == '' || isNaN(aInputs[x].value))) {
                        if (aInputs[x].value > 0) {
                            quantities.push(aInputs[x].value);
                            products.push(aInputs[x].getAttribute('productid'));
                        }
                    }
                }

                var formData = 'productid=' + products.toString();
                formData += '&quantity=' + quantities.toString();
                formData += '&labelwhid=' + iLabelwhid;
                formData += '&ipresetid=' + $('#templateName').val();

                $.ajax({
                    type: "POST",
                    url: "/Admin/Inventory/StockReceipt/StockReceiptBarcodes/zebraPrint.asp",
                    data: formData
                }).done(
                    function (data) {
                        //Set content to print...
                        //Create Zebra EPL commands for data label                  
                        cpj.printerCommands = data;
                        //Send print job to printer!
                        cpj.sendToClient();
                        hideLoading(btn, btn.value);
                    }).fail(
                        function (data) {
                            // Show alert
                            alert('There was an error in trying to print, please check that the printer is ready to print and try again. You may want to check how many labels actually printed and adjust the quantity that you still need to print.');
                            hideLoading(btn, btn.value);
                        });
            }
        }

        function zebraOnITOReportDownload(aQty, aProductIds, aWhidTo, reportType, downloadType) {

            aPrintValues.length = 0;
            aPrintQty.length = 0;
            aPrintWH.length = 0;

            for (var i in aWhidTo) {
                if (aPrintWH.filter(function (x) { return x == aWhidTo[i]; }).length == 0)
                    aPrintWH.push(aWhidTo[i]);
            }

            let printValues = new Array();
            let printQty = new Array();
            for (var i in aPrintWH) {
                printValues.length = 0;
                printQty.length = 0;
                for (var j in aWhidTo) {
                    if (aWhidTo[j] == aPrintWH[i]) {
                        let qty = parseInt(aQty[j]);
                        if (qty > 0) {
                            if (printValues.filter(function (x) { return x == aProductIds[0][j]; }).length == 0) {
                                printValues.push(aProductIds[0][j]);
                                printQty.push(qty);
                            }
                            else {
                                let index = printValues.indexOf(aProductIds[0][j]);
                                printQty[index] += parseInt(qty);
                            }
                        }
                    }
                }

                if (printValues.length > 0) {
                    aPrintValues.push(printValues.join());
                    aPrintQty.push(printQty.join());
                }
            }
            var printData = '';
            while (aPrintValues.length > 0) {

                var formData = 'productid=' + aPrintValues[0];
                formData += '&quantity=' + aPrintQty[0];
                formData += '&labelwhid=' + aPrintWH[0];
                formData += '&ipresetid=' + $('#templateName').val();
               
                var templateName = $("#templateName option:selected").text();
                var fileName = "Labels_" + templateName + "_" + reportType + ".epl";

                if (downloadType === 'ZPL') {
                    formData += '&idownloadzpl=true';
                    fileName = "Labels_" + templateName + "_" + reportType + ".zpl";
                }

                $.ajax({
                    type: "POST",
                    url: "/Admin/Inventory/StockReceipt/StockReceiptBarcodes/zebraPrint.asp",
                    data: formData,
                    async: false,
                    success: function (data) {
                        printData += data;
                    }
                });

                aPrintValues.shift();
                aPrintQty.shift();
                aPrintWH.shift();
            }

            if (printData != '') {
                downloadPrintCode(printData, fileName);
            }
        }

        function renderLinkZPL(elmName, templateid) {
            var formData = 'templateid=' + templateid;
            $.ajax({
                type: "POST",
                url: "/Admin/Inventory/StockReceipt/StockReceiptBarcodes/returnZPL.asp",
                data: formData,
                success: function (data) {
                    if (data != null && data != "") {
                        $("#bt-" + elmName + "-download-zpl").css({ "pointer-events": "auto", "cursor": "pointer", "color": "#337ab7" });
                        $("#ico-" + elmName + "-tooltip-zpl").css({ "display": "none" });
                    }
                    else {
                        $("#bt-" + elmName + "-download-zpl").css({ "pointer-events": "none", "cursor": "not-allowed", "color": "#bdb6b6" });
                        $("#ico-" + elmName + "-tooltip-zpl").css({ "display": "block" });
                    }
                }
            });
        }
        // SetCookie
        function setCookie(cName, cValue, expDays) {
            let date = new Date();
            date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
            const expires = "expires=" + date.toUTCString();
            document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";           
        }
        function resetJsPrintTemplate(iPresetId = null) {
            var arrName = ["LabelPrint","ProdEdit","StockReceipt","StockReceiptBasic","ITOReport"];
            for (var i in arrName) {              
             var tmp =  getZebraTemplate("ReX_ZebraTemplate_"+ arrName[i].toString());
                if (tmp == iPresetId) {         
                 setCookie("ReX_ZebraTemplate_" + arrName[i].toString(), '', 0);
                }
            }
        }

        //for prodEdit.asp
        function zebraOnProdEditDownload(downloadType) {
            var productId = document.getElementById('ProductID').value;
            var url = "BarcodePrinting/ProductBarcode.asp?id=" + productId + "&ipresetid=" + $('#templateName').val();
           
            var templateName = $("#templateName option:selected").text();
            var fileName = "Labels_" + templateName + "_Products.epl";

            if (downloadType === 'ZPL') {
                url += '&isDownloadZPL=true';
                fileName = "Labels_" + templateName + "_Products.zpl";
            }

            var warehouse = $("[name=ddlWarehouses]").val();
            if (warehouse != "") {
                url += "&whid=" + warehouse;
            }
            $.ajax({
                method: "POST",
                url: url,
                data: null,
                success: function (data) {
                    downloadPrintCode(data, fileName);
                }
            });
        }

        function zebraPrintOnProdEdit(btn, productId) {
            if (jspmWSStatus()) {
                showLoading(btn);
                //Create a ClientPrintJob
                var cpj = new JSPM.ClientPrintJob();
                cpj.clientPrinter = new JSPM.InstalledPrinter($('#installedPrinterName').val());

                var url = 'BarcodePrinting/ProductBarcode.asp?id=' + productId + '&ipresetid=' + $('#templateName').val();
                var warehouse = $("[name=ddlWarehouses]").val();
                if (warehouse != "") {
                    url += "&whid=" + warehouse;
                }

                $.ajax({
                    type: "POST",
                    url: url,
                    data: null
                }).done(
                    function (data) {
                        //Set content to print...
                        //Create Zebra EPL commands for data label                  
                        cpj.printerCommands = data;
                        //Send print job to printer!
                        cpj.sendToClient();
                        hideLoading(btn, btn.value);
                    }).fail(
                        function (data) {
                            // Show alert
                            alert('There was an error in trying to print, please check that the printer is ready to print and try again. You may want to check how many labels actually printed and adjust the quantity that you still need to print.');
                            hideLoading(btn, btn.value);
                        });
            }
        }

        // Loading 
        function showLoading(btn) {
            $(btn).html(' <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Loading...');
            $(btn).attr('disabled', 'disabled');
        }

        function hideLoading(btn, sValue) {
            $(btn).html(sValue);
            $(btn).removeAttr("disabled");
        }
        function disabledActionWhenNotemplate(lnkName, btnName) {       
            
            var tmpValue = $("#templateName").val();
            if (tmpValue === null || tmpValue === 'undefined' || tmpValue === 'No Templates Found') {
                $(("#zebraJsPrint" + btnName.replace(" ", ""))).attr("disabled", "disabled");
                $("#zebraJsPrint" + btnName.replace(" ", "")).removeClass("btn-js-print");
                if (lnkName !== "") {
                    $("#bt-" + lnkName.replace(" ", "") + "-download-epl").css({ "pointer-events": "none", "cursor": "not-allowed", "color": "#bdb6b6" });
                    $("#bt-" + lnkName.replace(" ", "") + "-download-zpl").css({ "pointer-events": "none", "cursor": "not-allowed", "color": "#bdb6b6" });
                }

                $(".glyphicon.icon-label-print").css({ "display": "block" });
            }

        }
        function modalReconfigOnITOReport(Label1, Label2) {           
            
            setZebraTemplate("ReX_ZebraTemplate_ITOReport");
            renderLinkZPL(Label1.replace(" ",""), $("#templateName option:selected").val());
            renderLinkZPL(Label2.replace(" ",""), $("#templateName option:selected").val());
            disabledActionWhenNotemplate(Label1, Label1);
            disabledActionWhenNotemplate(Label2, Label2);
        }
        function zebraJsPrintTestTemplate() {
            if (jspmWSStatus()) {
                //Create a ClientPrintJob
                var cpj = new JSPM.ClientPrintJob();
                cpj.clientPrinter = new JSPM.InstalledPrinter($('#installedPrinterName').val());
                var iProductId = parseInt(document.getElementById('test_productid').value);

                if (!isNaN(iProductId)) {
                    var url = "/Admin/Inventory/ProductMaint/BarcodePrinting/ProductBarcode.asp?" +
                        "id=" + iProductId +
                        "&desclimit=" + document.getElementById('description_width').value +
                        "&spf=" + document.getElementById('SellPriceField').options[document.getElementById('SellPriceField').selectedIndex].value +
                        "&spt=" + escape(document.getElementById('sellprice_text').value) +
                        "&sept=" + escape(document.getElementById('sellexprice_text').value) +
                        "&rpt=" + escape(document.getElementById('rrpprice_text').value) +
                        "&m1=" + escape(document.getElementById('misc1_text').value) +
                        "&m2=" + escape(document.getElementById('misc2_text').value) +
                        "&m3=" + escape(document.getElementById('misc3_text').value);
                    var formData = "sEPLCode=" + encodeURIComponent(document.getElementById('eplcode').value).replace(/\n/gi, "|");
                    $.ajax({
                        type: "POST",
                        url: url,
                        data: formData,
                        success: function (data) {
                            //Set content to print...
                            //Create Zebra EPL commands for data label
                            cpj.printerCommands = data;
                            //Send print job to printer!
                            cpj.sendToClient();
                        }
                    });
                } else {
                    alert("Please enter a valid Product ID");
                }
            }
        }
     
        return {
            InitJsPrintManager: initJsPrintManager,
            JsPrintClientStatus: jspmWSStatus,
            SetSelectedPrint: setSelectedPrint,
            ZebraPrintOnReceipt: zebraPrintOnReceipt,
            SetCookie: setCookie,
            SetZebraTemplate: setZebraTemplate,
            RenderLinkZPL: renderLinkZPL,
            ZebraOnReceiptDownload: zebraOnReceiptDownload,
            ZebraPrintOnITOReport: zebraPrintOnITOReport,
            ZebraOnITOReportDownload: zebraOnITOReportDownload,
            ZebraOnLabelPrintDownload: zebraOnLabelPrintDownload,
            ZebraPrintOnLabelPrint: zebraPrintOnLabelPrint,
            ZebraOnProdEditDownload: zebraOnProdEditDownload,
            ZebraPrintOnProdEdit: zebraPrintOnProdEdit,
            DisabledAction: disabledActionWhenNotemplate,
            ModalReconfigOnITOReport: modalReconfigOnITOReport,
            ResetJsPrintTemplate : resetJsPrintTemplate,
            ZebraJsPrintTest : zebraJsPrintTestTemplate,
            ShowLoading: showLoading,
            HideLoading: hideLoading
        };
    })();
    return backOffice.ZebraPrinting;
})(BackOffice || {}, jQuery);